import * as api from './adapter';

export default {
  index: () => ({
    data: {
      data: [
        {
          id: '020b39f4',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '02db4ced',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '0ae61044',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '16c5924a',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '25e6146e',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '263afa97',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '3341aee0',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '3e60c8ee',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '44a633c8',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '483b30e1',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '6f68a009',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '7fd42918',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '86f905ba',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: '95d3e9d2',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
        {
          id: 'b6181eb9',
          attributes: { text: 'very good', author: 'Alexander Kosachov' },
        },
      ],
      meta: { count: 19, page_count: 2 },
      links: {
        first: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=1&page%5Bsize%5D=15',
        next: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
        last: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
      },
    },
  }),
  /**
   * show
   * @param id
   * @return {Promise}
   */
  show: (id) => api.read(`/user_relatives/${id}`),
  /**
   * createCrewUser
   * @param attributes
   * @returns {Promise}
   */
  create: (attributes) => api.create({ type: 'user_relatives', attributes }),
  /**
   * updateCrewUser
   * @param id
   * @param attributes
   * @returns {Promise}
   */
  update: (id, attributes) => api.update({ id, type: 'user_relatives', attributes }),
  /**
   * deleteCrewUser
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'user_relatives' }),
};
